<template>
  <div class="simple-page">
    <i class="el-icon-edit"></i>

    <div :class="{ 'btn': true, 'next': true, 'disabled': page == 1 }" @click="handlePrevClick">
      <el-icon>
        <arrow-left />
      </el-icon>
    </div>
    <div class="btn current">{{ page }}</div>
    <div :class="{ 'btn': true, 'next': true, 'disabled': nextDisable }" @click="handleNextClick">
      <el-icon>
        <arrow-right />
      </el-icon>
    </div>
    <!-- <div class="btn reset"></div> -->
  </div>
</template>
<script>
import { ArrowLeft, ArrowRight } from '@element-plus/icons'
export default {
  emits: ['prev-click', 'next-click'],
  props: {
    page: {
      type: Number,
      default: 1
    },
    nextDisable: {
      type: Boolean,
      default: true
    }
  },
  components: {
    ArrowLeft,
    ArrowRight
  },
  data () {},
  methods: {
    handlePrevClick () {
      if (this.$props.page == 1) {
        return false
      }
      this.$emit('prev-click')
    },
    handleNextClick () {
      if (!this.$props.nextDisable) {
        return false
      }
      this.$emit('next-click')
    }
  }
}
</script>
<style lang="scss" scoped>
.simple-page {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  .btn {
    height: 28px;
    line-height: 28px;
    margin: 0 5px;
    background-color: #f4f4f5;
    color: #606266;
    min-width: 30px;
    border-radius: 2px;
    font-size: 13px;
    text-align: center;
    &.disabled {
      color: #c0c4cc;
      cursor: not-allowed;
      ::v-deep .el-icon {
        color: #c0c4cc;
      }
    }
    ::v-deep .el-icon {
      line-height: 32px;
      font-size: 14px;
      color: #606266;
      margin-top: 7px;
    }
  }
  .prev, .next {
    user-select: none;
    cursor: pointer;
  }
  .current {
    background-color: #409eff;
    color: #fff;
    user-select: none;
  }
}
</style>
